/*
  - Takes yours registered email and sends an OTP to registered email
  - Takes your new password and the otp recieved on mail and redirects you to login page
  - Commented by Sarthak on Feb 12, 2024
*/
import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { ValidationService } from '../../../app/validation.service';
import { AbstractControl, FormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthenticationServiceService } from '../../../app/authentication-service.service';
import { ChangeUsersService } from '../../../app/services/change-users.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  public hasErrors: Boolean = false;
  public errorMessage = '';
  public loginErrorCode = '';
  public loginErrorMessage = '';
  public username = '';
  public password = '';
  public userForm: any;
  public role: any;
  public pageRef: any;
  public returnUrl: string;
  public email: string;
  customer: any;

  emailBoxMain:boolean = true;
  resetPasswordBoxMain:boolean = false;
  emailID:string;
  constructor(private router: Router, public changeUserDashboard: ChangeUsersService, private authenticationService: AuthenticationServiceService, private route: ActivatedRoute, private formBuilder: FormBuilder) { }
  
    /*
    - Navigates to login page
    - Link :: https://dev.enertics.ca/#/login
    - Commented by Sarthak on Feb 12, 2024
  */
  goToLogin(){
    this.router.navigate(['login']);
  }
  
  /*
    - Sends otp to emails entered
    - and renders the newPassword and OTP field to enter otp recieved and new password
    - Commented by Sarthak on Feb 12, 2024
  */
  public sendEmail(): void {
    this.emailID = this.userForm.value.email;
    this.resetPasswordBoxMain = true;
    this.emailBoxMain = false;
    if(this.resetPasswordBoxMain === true){
      this.userForm = this.formBuilder.group({
        'new_password': ['', [Validators.required, ValidationService.passwordValidator]],
        'otp':['', [Validators.required]]
      });
    }
  }

  /*
    - Stores new Password
    - Stores otp entered
    - Function is incomplete
    - Commented by Sarthak on Feb 12, 2024
  */
  async resetPassword(){
    var body = JSON.stringify({
      "new_password": this.userForm.value.new_password,
      "otp": this.userForm.value.otp,
      "email": this.emailID
    });
  }
  /*
    - Creates userForm and sets email to empty string on rendering this component for first time
    - Commented by Sarthak on Feb 12, 2024
  */
  ngOnInit() {
    this.userForm = this.formBuilder.group({
      'email': ['', [Validators.required]]
    });
  }
  /*
    - Routes to undefined
    - Route isn't created yet to register a new user
    - Commented by Sarthak on Feb 12, 2024
  */
  async signupScreen() {
    this.router.navigate(['/auth/register']);
  }
  /*
    - Routes to https://dev.enertics.ca/#/forgot-password which is current page
    - Commented by Sarthak on Feb 12, 2024
  */
  goToForgotPassword() {
    this.router.navigate(['forgot-password'])
  }

}